import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { read } from '../controllers/work-order';
import { useAuth } from '../use-auth';

import { DateSpan, NumberSpan } from '../widgets';

import './print-form.css';
import './work-order-form.css';

const numberFmt = Intl.NumberFormat('en-US', {
  style: 'decimal',
  // minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});  

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export function WorkProcessForm(props) {
  const [doc, setDoc] = useState({})
  const { id } = useParams();
  const query = useQuery();

  const auth = useAuth();
  const lang = query.get('lang') || auth.lang || 'en';
  const locale = lang === 'th'? 'th-TH': 'en-UK';

  const dateOpts = { day: 'numeric', month: 'short', year: 'numeric' };
  const dateFmt = new Intl.DateTimeFormat(locale || 'en-UK', dateOpts);

  useEffect(() => {
    read(id).then((data) => {
      // console.info(data);

      while(data.specs.length < 10) data.specs.push({});
      while(data.formulas.length < 10) data.formulas.push({});
      while(data.process.length < 10) data.process.push({});
      console.info(data.work_remark);
      if(data.work_remark && data.work_remark !== '') {
        data.work_remark = data.work_remark.split('\n', 4);
      } else {
        data.work_remark = [];
      }

      while(data.work_remark.length < 4) data.work_remark.push('');

      setDoc(data);
      setTimeout(window.print, 500); // Ensure data is render completed
      if(window.opener) {
        setTimeout(window.close, 1000);
      }
  
    })
    // console.info(window.opener);
  }, [id])

  return (
    <React.Fragment>
      <table className="outer-main" border="0">
        <thead>
          <tr>
            <th colSpan="5" className="center">
              <h2>คำสั่งการผลิต</h2>
            </th>
          </tr>
          <tr>
            <th colSpan="5" className="center">
              <h2>Work Order</h2>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td className="right">เลขที่คำสั่ง : </td>
            <td>{doc.work_no}</td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td className="right">วันที่สั่งงาน : </td>
            <td><DateSpan dateFmt={dateFmt} value={doc.work_date} /></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td className="right">กำหนดส่ง : </td>
            <td><DateSpan dateFmt={dateFmt} value={doc.due_date} /></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              &nbsp;
              <br />
            </td>
          </tr>

          <tr>
            <td className="right">ชื่อลูกค้า : </td>
            <td>{doc.contact_name}</td>
            <td></td>
            <td className="right">ชื่อสินค้า : </td>
            <td>{doc.product_name}</td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td className="right">จำนวนที่ต้องการ : </td>
            <td><NumberSpan numberFmt={numberFmt} value={doc.order_qty} /> {doc.order_unit}</td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <br />
      <table className="outer-main">
        <thead>
          <tr>
            <td>
              <h6>ข้อกำหนด/ความต้องการ</h6>
            </td>
            <td>
              <h6>วัตถุดิบในการผลิต / สูตรการผลิต ต่อ 1 หน่วย</h6>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td valign="top" style={{height:"350px", paddingRight:"0.25rem"}}>
              <SpecList items={doc.specs} />
            </td>
            <td valign="top" style={{height:"350px", paddingLeft: "0.25rem"}}>
              <MaterialList items={doc.formulas} />
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <table className="outer-main">
        <thead>
          <tr>
            <td>
              <h6>ขั้นตอนการผลิต</h6>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td valign="top" style={{ width: '70%', height:"350px" }}>
              <ProcessStepList items={doc.process} dateFmt={dateFmt} />
            </td>
            <td valign="top" style={{padding: "0.5rem"}}>
              {/* <Summary doc={doc} /> */}
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <div className="round-box outer-main">
        <h6>หมายเหตุ</h6>
        <table style={{width:"100%"}}>
          <tbody>
            {doc.work_remark && doc.work_remark.map((t, i) => {
              return <tr key={i}>
              <td style={{borderBottom: "1px dotted black"}}>{t}<br /></td>
            </tr>
            })}
          </tbody>
        </table>
      </div>
      <br />
      <Signature />
      <br />
      (โปรแกรมคำสั่งผลิต Work Cube by CRK Solution Co., Ltd.)
    </React.Fragment>
  );
}

function SpecList({items}) {
  return (
    <table id="tbl-spec" border="1" style={{ width: '100%' }}>
      <thead>
        <tr>
          <th className="center">#</th>
          <th>หัวข้อ</th>
          <th>กำหนด</th>
          <th>หน่วย</th>
        </tr>
      </thead>
      <tbody>
        {items &&
          items.map((t, i) => {
            return (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>
                  {t.spec_detail}
                  <br />
                </td>
                <td>
                  {t.spec_value}
                  <br />
                </td>
                <td>
                  {t.spec_unit}
                  <br />
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
}

function MaterialList({items}) {
  return (
    <table id="tbl-mat" border="1" style={{ width: '100%' }}>
      <thead>
        <tr>
          <th>#</th>
          <th>วัตถุดิบ</th>
          <th>จำนวน</th>
          <th>หน่วย</th>
        </tr>
      </thead>
      <tbody>
        {items &&
          items.map((t, i) => {
            return (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>
                  {t.mat_name}
                  <br />
                </td>
                <td>
                  {t.mat_usage}
                  <br />
                </td>
                <td>
                  {t.mat_unit}
                  <br />
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
}

function ProcessStepList({items, dateFmt}) {
  return (
    <table id="tbl-job" border="1" style={{ width: '100%' }}>
      <thead>
        <tr>
          <th>#</th>
          <th>ขั้นตอน</th>
          <th>เวลาที่ใช้</th>
          <th>หน่วย</th>
          <th>หมายเหตุ</th>
        </tr>
      </thead>
      <tbody>
        {items && items.map((t, i) => {
          return (<tr key={i}>
          <td>{i+1}</td>
          <td>
            {t.process_name}<br />
          </td>
          <td>
            {t.process_time}<br />
          </td>
          <td>
            {t.process_unit}<br />
          </td>
          <td>
            {t.process_remark}<br />
          </td>
        </tr>)
        })}
        
      </tbody>
    </table>
  );
}

function Summary({doc}) {
  return (
    <table style={{width:"100%"}}>
      <thead>
        <tr>
          <th colSpan="2">
            <h6>สรุปผล</h6>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>ผลิตทั้งหมด</td>
          <td className="right"><NumberSpan numberFmt={numberFmt} value={doc.qty_total} /> {doc.order_unit}</td>
        </tr>
        <tr>
          <td>NG : เสียหาย</td>
          <td className="right"><NumberSpan numberFmt={numberFmt} value={doc.qty_ng} /> {doc.order_unit}</td>
        </tr>
        <tr>
          <td>Good : สินค้าดี</td>
          <td className="right"><NumberSpan numberFmt={numberFmt} value={doc.qty_good} /> {doc.order_unit}</td>
        </tr>
      </tbody>
    </table>
  );
}

function Signature(props) {
  return (
    <table className="outer-main">
      <tbody>
        <tr>
          <td width="25%" className="center sign-box">
            ผู้สั่งผลิต
            <br />
            <br />
            <br />
            (............................................................)
            <br />
            วันที่ ........../........../..........
          </td>
          <td width="2%"></td>
          <td width="25%" className="center sign-box">
            ผู้ตรวจสอบสินค้า
            <br />
            <br />
            <br />
            (............................................................)
            <br />
            วันที่ ........../........../..........
          </td>
          <td width="2%"></td>
          <td width="25%" className="center sign-box">
            ผู้รับสินค้า
            <br />
            <br />
            <br />
            (............................................................)
            <br />
            วันที่ ........../........../..........
          </td>
        </tr>
      </tbody>
    </table>
  );
}
